import { Suspense } from 'react';
import { Link } from 'react-router-dom';
import { useAtomValue } from 'jotai';
import T from '@wojtekmaj/react-t';

import { Wrapper } from './plan_subscription_issues_banner.styles';

import useAccountPermission from '../../../hooks/useAccountPermission';

import { currentPlanSubscriptionState } from '../../../store';

function PlanSubscriptionIssuesBannerContent() {
  const currentPlanSubscription = useAtomValue(currentPlanSubscriptionState);

  const shouldDisplayAdminMessage = useAccountPermission('payment_details_view');

  if (!currentPlanSubscription || !currentPlanSubscription.has_issues) {
    return null;
  }

  return (
    <Wrapper>
      {shouldDisplayAdminMessage ? (
        <>
          <p>
            <T>
              We’ve identified an issue with your subscription that may affect the functionality of
              your account.
            </T>{' '}
            <T>Please contact our support team for quick assistance.</T>
          </p>
          <Link to="#contact-us">
            <T>Contact us</T>
          </Link>
        </>
      ) : (
        <p>
          <T>
            We’ve identified an issue with your subscription that may affect the functionality of
            your account.
          </T>{' '}
          <T>Please contact your administrator.</T>
        </p>
      )}
    </Wrapper>
  );
}

export default function PlanSubscriptionIssuesBanner() {
  return (
    <Suspense fallback={null}>
      <PlanSubscriptionIssuesBannerContent />
    </Suspense>
  );
}
